import React, { useEffect } from "react";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { axiosPrivate } from "../api/axios";
import {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
} from "axios";
import { toast } from "sonner";
import { User } from "@/hooks/types";

interface UseAuth {
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
}

export const AxiosInterceptorSetup: React.FC = () => {
  const { user, setUser }: UseAuth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const requestIntercept = axiosPrivate.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        if (!config.headers["Authorization"] && user?.access_token) {
          config.headers["Authorization"] = `Bearer ${user.access_token}`;
        }
        return config;
      },
      (error: AxiosError) => Promise.reject(error)
    );

    const responseIntercept = axiosPrivate.interceptors.response.use(
      (response) => response,
      async (error: AxiosError) => {
        const prevRequest = error.config as AxiosRequestConfig & {
          send?: boolean;
        };

        if (error.response?.status === 401 && !prevRequest.send) {
          prevRequest.send = true;
          localStorage.removeItem("WA-auth");
          setUser(null);
          navigate("/login");
          toast.error("Session has timed out! Please Login again");
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosPrivate.interceptors.request.eject(requestIntercept);
      axiosPrivate.interceptors.response.eject(responseIntercept);
    };
  }, [user?.access_token, setUser, navigate]);

  return null; // This component doesn't render anything
};
